import React, { useState } from 'react';
import { Row, Paragraph } from './CreditCheck.styles';
import { Spinner } from 'view/components/layout';
import { CardBody, CardFooter, CardHeader, Button, FormCharInput } from 'view/components/common';
import { orderCreditCheck } from 'core/api/underwriting';
import { useToast } from 'core/toast';

interface CreditCheckProps 
{
    stepNavigator      : (increment: boolean) => () => void;
    hasConsumerReport  : boolean;
}

export const CreditCheck: React.FunctionComponent<CreditCheckProps> = ({ hasConsumerReport, stepNavigator }) => 
{
    const [ loading, setLoading ] = useState<boolean>(false);
    const [ sinNumber, setSinNumber ] = useState<string>('');
    const { setToastMessage } = useToast();

    const onSubmit = async () => 
    {
        setLoading(true);

        if (hasConsumerReport) 
        {
            onSubmitSuccess();
        }
        else 
        {
            const {
                success,
                error
            } = await orderCreditCheck(sinNumber);

            if (success)
            {
                onSubmitSuccess();
            }
            else 
            {
                setLoading(false);
                setToastMessage(error);
            }
        }

    };

    const onSubmitSuccess = () => 
    {
        setTimeout(() => 
        {
            setLoading(false);
            stepNavigator(true)();
        }, 500);
    };

    const hasEnteredSin = sinNumber.length === 9;

    return (
        <>
            <CardHeader
                content={'Credit Check'}
                step={'Step 3'}
                backHandler={stepNavigator(false)}
            />
            <CardBody>
                {loading ? (
                    <Spinner css='height: inherit; margin-top: 175px;' />
                ) : (
                    <>
                        <Row>
                            <Paragraph>
                                Collecting your SIN is a secure process where we use it to pull your credit report from Equifax. This is a one time operation that will result in a hard hit to your credit. We do not store your SIN once complete.
                            </Paragraph>
                        </Row>
                        <br />
                        <Row>
                            <Paragraph>
                                Enter your SIN number
                            </Paragraph>
                        </Row>
                        <Row>
                            <FormCharInput
                                count={9}
                                autoFocus={true}
                                inputRegex={/[0-9]/}
                                input={{ value: '', onChange: setSinNumber }}
                            />
                        </Row>
                    </>
                )}
            </CardBody>
            <CardFooter>
                <Button
                    title="Authorize Credit Check"
                    type="button"
                    disabled={hasConsumerReport ? false : !hasEnteredSin || loading}
                    onClick={onSubmit}
                    css={'text-transform: none; padding-bottom: 3px;'}
                    arrowCss={'padding-left: 0px; margin-top: 5px;'}
                />
            </CardFooter>
        </>
    );
};
